(() => {
  // Impide instalar el seguimiento dos veces en la misma página.
  if (window.tecnoplazaRelatedTrackingLoaded) return;
  window.tecnoplazaRelatedTrackingLoaded = true;

  const blockSelector = ".related-products[data-product-id]";
  const observedCards = new WeakSet();
  const recordedImpressions = new Set();

  function cleanProductName(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 100);
  }

  function getSourceProductName() {
    const heading =
      document.querySelector(".product__title h1") ||
      document.querySelector("main h1");

    return heading ? cleanProductName(heading.textContent) : "";
  }

  function getRecommendedProductName(card) {
    const heading =
      card.querySelector(".card__heading a") ||
      card.querySelector(".card__heading");

    if (heading) {
      const name = cleanProductName(heading.textContent);
      if (name) return name;
    }

    const links = card.querySelectorAll('a[href*="pr_rec_pid="]');

    for (const link of links) {
      const name = cleanProductName(link.textContent);
      if (name) return name;
    }

    return "";
  }

function getProductData(card) {
  const block = card.closest(blockSelector);

  if (!block) return null;

  let sourceId = block.dataset.productId;
  let recommendedId = card.dataset.recommendedProductId;

  // Compatibilidad con las tarjetas anteriores de Search & Discovery.
  if (!recommendedId) {
    const link = card.querySelector('a[href*="pr_rec_pid="]');

    if (!link) return null;

    const url = new URL(link.href, window.location.origin);

    sourceId = url.searchParams.get("pr_ref_pid") || sourceId;
    recommendedId = url.searchParams.get("pr_rec_pid");
  }

  if (!sourceId || !recommendedId) return null;

  const data = {
    source_product_id: String(sourceId),
    recommended_product_id: String(recommendedId)
  };

  const sourceName = getSourceProductName();
  const recommendedName = getRecommendedProductName(card);

  if (sourceName) {
    data.source_product_name = sourceName;
  }

  if (recommendedName) {
    data.recommended_product_name = recommendedName;
  }

  return data;
}


  function publish(eventName, data) {
    if (
      !window.Shopify ||
      !window.Shopify.analytics ||
      typeof window.Shopify.analytics.publish !== "function"
    ) {
      return false;
    }

    try {
      Promise.resolve(
        window.Shopify.analytics.publish(eventName, data)
      ).catch(() => {});
      return true;
    } catch (_) {
      // Un error de medición nunca debe afectar al enlace.
      return false;
    }
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // Impresión: al menos el 50 % de la tarjeta visible.
      if (!entry.isIntersecting || entry.intersectionRatio < 0.5) {
        return;
      }

      const data = getProductData(entry.target);
      if (!data) return;

      const key =
        data.source_product_id + ":" + data.recommended_product_id;

      if (recordedImpressions.has(key)) {
        observer.unobserve(entry.target);
        return;
      }

      if (publish("related_product_impression", data)) {
        recordedImpressions.add(key);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  function observeCards() {
    document.querySelectorAll(
      blockSelector + " ul.product-grid > li.grid__item"
    ).forEach((card) => {
      if (observedCards.has(card)) return;
      observedCards.add(card);
      observer.observe(card);
    });
  }

  // Un único listener, aunque una tarjeta tenga varios enlaces.
  document.addEventListener("click", (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest("a[href]");
    if (!link || !link.closest(blockSelector)) return;

    const card = link.closest("li.grid__item");
    if (!card) return;

    const data = getProductData(card);
    if (!data) return;

    publish("related_product_click", data);

    // No se bloquea ni se cambia la navegación.
  });

  // Las recomendaciones pueden aparecer después de cargar la página.
  let scanScheduled = false;

  const changes = new MutationObserver(() => {
    if (scanScheduled) return;
    scanScheduled = true;

    requestAnimationFrame(() => {
      scanScheduled = false;
      observeCards();
    });
  });

  changes.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  observeCards();
})();
